/* MAV3D Redesign 01.11.2026: Einblenden (gestaffelt, einmalig) + Stationswahl im Startbild. Ohne JS bleibt alles sichtbar und klickbar. */
(function () {
  if (window.__mx) return;
  window.__mx = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Stationswahl: Klick wechselt Bild, Name, Preis und Link; Strg/Cmd-Klick öffnet weiterhin das Produkt */
  /* Nutzer 01.11.2026: die Staubbehälter laufen von selbst durch (alle 4,5 s). Pause bei Maus/Fokus, Schluss nach dem ersten Klick,
     angehalten bei verborgenem Tab; bei prefers-reduced-motion kein Durchlauf. */
  function wahl(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-mx-wahl-btn]'));
    function zeige(btn) {
      var fig = root.querySelector('[data-mx-wahl-fig="' + btn.getAttribute('data-mx-wahl-btn') + '"]');
      if (!fig) return false;
      btns.forEach(function (b) { b.classList.remove('is-on'); b.removeAttribute('aria-current'); });
      btn.classList.add('is-on'); btn.setAttribute('aria-current', 'true');
      root.querySelectorAll('[data-mx-wahl-fig]').forEach(function (f) { f.hidden = true; f.classList.remove('is-on'); });
      fig.hidden = false; fig.classList.add('is-on');
      return true;
    }
    var gestoppt = reduce || btns.length < 2, pause = false;
    root.addEventListener('mouseenter', function () { pause = true; });
    root.addEventListener('mouseleave', function () { pause = false; });
    root.addEventListener('focusin', function () { pause = true; });
    root.addEventListener('focusout', function () { pause = false; });
    if (!gestoppt) setInterval(function () {
      if (gestoppt || pause || document.hidden) return;
      var i = btns.findIndex(function (b) { return b.classList.contains('is-on'); });
      zeige(btns[(i + 1) % btns.length]);
    }, 4500);
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mx-wahl-btn]');
      if (!btn || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      gestoppt = true;
      if (btn.classList.contains('is-on')) return; /* zweiter Klick auf die aktive Station öffnet das Produkt */
      if (zeige(btn)) e.preventDefault();
    });
  }

  function init() {
    document.querySelectorAll('[data-mx-wahl]').forEach(wahl);
    if (!('IntersectionObserver' in window) || reduce) return;
    document.documentElement.classList.add('mx-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    document.querySelectorAll('.mx').forEach(function (sec) {
      var n = 0;
      sec.querySelectorAll('.mx-rise:not(.is-in)').forEach(function (el) {
        el.style.setProperty('--i', Math.min(n++, 7));
        io.observe(el);
      });
    });
    /* Sicherheitsnetz: nach 6 s ist alles sichtbar */
    setTimeout(function () { document.querySelectorAll('.mx-rise').forEach(function (el) { el.classList.add('is-in'); }); }, 6000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { window.__mx = false; });
})();
